import { useMutation } from '@tanstack/react-query';
import IIMRunsService from '../services/IIMRunsService';
export function useRunIA(options) {
    return useMutation((params) => IIMRunsService.createIIMRun(params), {
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        retry: false
    });
}
export default useRunIA;
